/**
 * @generated SignedSource<<3420e8ff6fe8f3c6162ed9d5fa0cc552>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CustomsMessagingBody_viewer$data = {
  readonly dutiesClassification: {
    readonly duties: string | null;
  } | null;
  readonly " $fragmentType": "CustomsMessagingBody_viewer";
};
export type CustomsMessagingBody_viewer$key = {
  readonly " $data"?: CustomsMessagingBody_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CustomsMessagingBody_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "shippingAddressId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CustomsMessagingBody_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        },
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        },
        {
          "kind": "Variable",
          "name": "shippingAddressId",
          "variableName": "shippingAddressId"
        }
      ],
      "concreteType": "DutiesClassification",
      "kind": "LinkedField",
      "name": "dutiesClassification",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "duties",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "a9175829b6bd06edbb50a7291ee21bf2";

export default node;
